import {useMemo} from 'react';

import {LinePlotSettings} from '../../WorkspaceDrawer/Settings/types';
import {LINE_PLOT_TEMPLATE_FIELDS} from '../constants';
import {
  LinePlotTemplateSettings,
  WorkspaceTemplate,
} from '../workspaceTemplatesQueries';
import {LINE_PLOT_TEMPLATE_DISPLAY_FNS} from './linePlotTemplateDisplayFns';

export const useLinePlotTemplateSections = ({
  currTemplateLinePlotSettings,
  currWorkspaceLinePlotSettings,
  isBackendSmoothingEnabled,
}: {
  currTemplateLinePlotSettings: WorkspaceTemplate['linePlotSettings'];
  currWorkspaceLinePlotSettings?: LinePlotSettings;
  isBackendSmoothingEnabled: boolean;
}) => {
  return useMemo(() => {
    return [
      {
        title: 'Data',
        rows: LINE_PLOT_TEMPLATE_FIELDS.map(key => {
          return LINE_PLOT_TEMPLATE_DISPLAY_FNS[key]({
            isBackendSmoothingEnabled,
            currTemplateLinePlotSettings,
            currWorkspaceLinePlotSettings,
          });
        }),
      },
    ];
  }, [
    currTemplateLinePlotSettings,
    currWorkspaceLinePlotSettings,
    isBackendSmoothingEnabled,
  ]);
};

/**
 * These are values that should be copied over to the default spec when
 * a template is applied.
 */
export const getLinePlotTemplateValues = (
  workspaceTemplate: WorkspaceTemplate | undefined
): LinePlotSettings => {
  const templateLinePlotSettings = workspaceTemplate?.linePlotSettings;
  if (templateLinePlotSettings == null) {
    return {};
  }

  const linePlotSettings = LINE_PLOT_TEMPLATE_FIELDS.reduce<LinePlotSettings>(
    (acc, key: keyof LinePlotTemplateSettings) => {
      const templateValue = templateLinePlotSettings[key];

      // If a template value is undefined, there's no need to copy it over to spec
      // since that's the default already
      if (templateValue != null) {
        // This is safe to do since we've constrainted the types from the query already
        acc[key] = templateValue as any;
      }
      return acc;
    },
    {}
  );

  return linePlotSettings;
};
